<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'App',
        methods: {
            ...mapActions([
                'setUserLoginAuth',
                'setUserRemember',
                'setUserContractTitle',
                'setUserPasswordValue',
                'setUserIpAuth',
                'setUserCities',
                'loadCities',
            ])
        },
        computed: {
            ...mapGetters([
                'getProcessStatus',
                'getUserContractId',
            ])
        },
        created() {
            let component = this;
            this.loadCities((resp, data) => {
                let userCities = [];
                data.forEach((city) => {
                    userCities.push({
                        text: city.city,
                        value: city.id,
                        phone: '',
                        code: '',
                        support_phone: '',
                    });
                });
                component.setUserCities(userCities);
            });
            let contract = this.$cookie.get("contract");
            let password = this.$cookie.get("password");
            if (contract !== null && password !== null) {
                this.setUserRemember(true);
                this.setUserContractTitle(contract);
                this.setUserPasswordValue(password);
                this.setUserLoginAuth({
                    'redirect': false,
                    'router': this.router
                });
            } else if (this.getProcessStatus('userIp') === null && this.getUserContractId === '')
                this.setUserIpAuth();
        }
    }
</script>

<style lang="stylus">
    @import '../node_modules/vuetify/src/stylus/main';

    div.layout {
        margin: 0;
    }

    ::-webkit-scrollbar {
        width: 0;
    }

    scrollbar[orient="vertical"] {
        width: 0;
    }

    .i {
        font-style: italic !important;
    }

    .b {
        font-weight: bold !important;
    }

    .ac {
        align-self: center;
    }

    .at {
        align-self: flex-start;
    }

    .ab {
        align-self: flex-end;
    }

    .hr {
        border-bottom: 1px solid #e1e1e1;
    }

    .hr-b {
        border-bottom: 1px solid #b4b4b4;
    }

    .o7 {
        opacity: 0.7;
        transition: opacity 0.3s ease;
    }

    .o7:hover, .o7.selected {
        opacity: 1;
    }

    .o5 {
        opacity: 0.5;
        transition: opacity 0.3s ease;
    }

    .o5:hover, .o5.selected {
        opacity: 1;
    }

    .m0 {
        margin: 0;
    }

    .no_shadow {
        box-shadow: none !important;
    }

    .small_button div {
        min-width: 54px;
        margin: 0;
        padding-left: 2px !important;
        padding-right: 2px !important;
    }

    .sb div {
        padding: 2px;
    }

    .sb {
        min-width: 50px;
    }

    .bl {
        border-left: 1px solid #e1e1e1;
    }

    .br {
        border-right: 1px solid #e1e1e1;
    }

    .bt {
        border-top: 1px solid #e1e1e1;
    }

    .bb {
        border-bottom: 1px solid #e1e1e1;
    }

    div.rowbox {
        max-width: 1920px;
        width: 100%;
        margin: 0 auto;
        min-width: 320px;
    }

    .hoverbox {
        box-shadow: 0 0 7px transparent;
        transition: box-shadow .3s ease;
    }

    .hoverbox:hover {
        box-shadow: 0 3px 7px #838383 !important;
    }

    .hovertext {
        text-shadow: 0 0 1px transparent;
        transition: text-shadow .3s ease;
    }

    .hovertext:hover {
        text-shadow: 0 0 1px black;
    }

    .dashline {
        border-bottom: 1px dashed #373737;
    }

    .fill-width {
        width: 100%;
    }

    .em0-5 {
        font-size: 0.5em;
    }

    .em0-6 {
        font-size: 0.6em;
    }

    .em0-7 {
        font-size: 0.7em;
    }

    .em0-8 {
        font-size: 0.8em;
    }

    .em0-9 {
        font-size: 0.9em;
    }

    .em1-0 {
        font-size: 1.0em;
    }

    .em1-2 {
        font-size: 1.2em;
    }

    .em1-4 {
        font-size: 1.4em;
    }

    .em1-6 {
        font-size: 1.6em;
    }

    .em1-8 {
        font-size: 1.8em;
    }

    .em2-0 {
        font-size: 2.0em;
    }

    .em2-3 {
        font-size: 2.3em;
    }

    .em2-6 {
        font-size: 2.6em;
    }

    .em2-9 {
        font-size: 2.9em;
    }

    .em3-3 {
        font-size: 3.3em;
    }

    .em3-6 {
        font-size: 3.6em;
    }

    .em3-9 {
        font-size: 3.9em;
    }

    .em4-3 {
        font-size: 4.3em;
    }

    .em4-6 {
        font-size: 4.6em;
    }

    .em4-9 {
        font-size: 4.9em;
    }

    .b {
        font-weight: 500;
    }

    .bolder {
        font-weight: bolder;
    }

    .v-btn {
        text-transform: inherit;
        border-radius: 10px !important;
    }

    .btn-small {
        padding: 0 8px;
    }

    .btn-smallest {
        padding: 0 2px;
        min-width: auto !important;
    }

    .daxline {
        font-family: Daxline;
    }

    .fade-enter-active, .fade-leave-active, .fade-leave-to {
        transition: .3s ease-out;
        position: absolute;
        top: 0;
        left: 0;
    }

    .fade-enter, .fade-leave, .fade-leave-to {
        opacity: 0
    }

    .viewer-enter-active, .viewer-leave-active, .viewer-leave-to {
        transition: .3s ease-out;
        position: absolute;
    }

    .viewer-enter, .viewer-leave, .viewer-leave-to {
        transition: .3s ease-out;
        opacity: 0
    }

    .bottomdrop-enter-active {
        transition: .3s ease-out;
        height: 0;
    }

    .bottomdrop-enter, .bottomdrop-leave, .bottomdrop-leave-to {
        height: 0;
    }

    .text-shadow {
        text-shadow: 1px 1px #444;
    }

    .no-decoration {
        text-decoration: none;
    }

    .pointer:hover {
        cursor: pointer;
    }

    .router-button {
        display: inline;
        border-bottom: 1px solid transparent;
    }

    .router-button.selected {
        transition: all .3s ease;
        color: #e15d3d !important;
    }

    .router-button:hover {
        transition: all .3s ease;
        color: #191919;
        border-bottom: 1px solid grey;
    }

    .layka-orange {
        background-color: #e15d3d !important;
        border-color: #e15d3d !important;
    }

    .layka-orange-text {
        color: #e15d3d !important;
    }
</style>




// WEBPACK FOOTER //
// src/App.vue